import { Box, Typography } from '@mui/material';
import { grey, lightBlue } from '@mui/material/colors';
import { makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';

import HtmlDiff from '@/util/HtmlDiff';

import ReactComponent from '../ReactComponent';

class ComparadorTextos extends ReactComponent {
    diff;

    constructor(props) {
        super(props);

        makeObservable(this, {
            diff: observable
        });
    }

    render() {
        const { conteudoAntigo, conteudoNovo, labelConteudoAntigo, labelConteudoNovo } = this.observableProps;

        if (conteudoAntigo === null || conteudoAntigo === undefined) {
            throw new ReferenceError(`Parâmetro inválido: conteúdo antigo não pode ser nulo.`);
        }

        if (conteudoNovo === null || conteudoNovo === undefined) {
            throw new ReferenceError(`Parâmetro inválido: conteúdo novo não pode ser nulo.`);
        }

        if (!this.diff) {
            const htmlDiff = HtmlDiff.execute(this.observableProps.conteudoAntigo, this.observableProps.conteudoNovo);
            runInAction(() => (this.diff = htmlDiff));
        }

        const diffStyles = `
            del.diffdel {
                background-color: LightPink;
            }

            del.diffmod {
                background-color: LightPink;
            }

            ins.diffmod {
                background-color: PaleGreen;
                text-decoration: initial;
            }

            ins.diffins {
                background-color: PaleGreen;
                text-decoration: initial;
            }

            figure del.diffmod,
            figure ins.diffmod,
            figure ins.diffins,
            figure del.diffdel {
                display: block;
            }

            figure {
                text-align: center;
            }
        `;

        const estiloBoxEstrutura = { border: `1px solid ${grey[200]}`, borderRadius: '5px', p: 2, flex: 1 };
        const estiloTitulo = { fontWeight: 'bold', color: lightBlue[900], mb: 0.5 };

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <style>{diffStyles}</style>

                <Box sx={estiloBoxEstrutura}>
                    <Typography sx={estiloTitulo}>Comparação de conteúdo:</Typography>
                    <Box
                        data-sentry-mask
                        dangerouslySetInnerHTML={{ __html: this.diff }}
                    />
                </Box>

                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Box sx={estiloBoxEstrutura}>
                        <Typography sx={estiloTitulo}>{labelConteudoAntigo ?? 'Texto anterior'}:</Typography>
                        <Box>{conteudoAntigo}</Box>
                    </Box>

                    <Box sx={estiloBoxEstrutura}>
                        <Typography sx={estiloTitulo}>{labelConteudoNovo ?? 'Texto novo'}:</Typography>
                        <Box>{conteudoNovo}</Box>
                    </Box>
                </Box>
            </Box>
        );
    }
}

export default inject('stores')(observer(ComparadorTextos));
